import './popinActivity.css';

const sliderPhotosModule = () => import(/* webpackChunkName: 'components/sliderPhotos' */'../sliderPhotos/sliderPhotos');
const virtualTourModule = () => import(/* webpackChunkName: 'components/virtualTour' */'../virtualTour/virtualTour');

import { popinActivityTpl } from './popinActivityTpl';

let fancyCloseType = 'implicit',
  fancyboxOptions = {
    topRatio: 0.5,
    fitToView: true,
    padding: 0,
    touch: false,
    baseClass: 'popinActivity-fancybox',
    afterClose: () => {
      //handling close tracking
      Tracking.dataLayerPush({
        clickCode: 'clickPopinExit',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'activityDetails',
        gaLabel: fancyCloseType,
        gaValue: 1,
        event: 'clickEvent'
      });
      fancyCloseType = 'Implicit';
    },
    afterShow: () => {
      //specify trackingCloseType on click on close button
      $('.fancybox-close-small').on('click', () => {
        fancyCloseType = 'Explicit';
      });
    }
  };

export const popinActivity = {
  cacheDataPopin: [],

  init: function () {
    dispatcher.listenTo(dispatcher, 'popinActivity:anchorToPrices', () => {
      const $btn = $('.js-showPrices');
      Tracking.dataLayerPush({
        clickCode: 'clickActivitiesBlock',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Click on price activity details',
        gaLabel: $btn.hasClass('toggle-active') ? $btn.attr('toggleopentext') : $btn.attr('toggleclosetext'),
        event: 'clickEvent'
      });

      if (DEVICE.isTablet || DEVICE.isMobile) {
        $('.popinActivity').animate({
          scrollTop: $btn.offset().top
        }, 300);
      }
    });

    $(document).on('click', '.js-domainActivitiesPopin, .popinActivity-arrow', (event) => {
      event.preventDefault();
      const dataCode = $(event.currentTarget).attr('data-code');
      const $vignetTarget = $('.js-domainActivitiesPopin[data-code="'+dataCode+'"]');
      const dataNextCode =  $vignetTarget.next().length ? $vignetTarget.next().attr('data-code') : false;
      const dataPrevCode = $vignetTarget.prev().length ? $vignetTarget.prev().attr('data-code') : false;
      const successCallback = () => {
        const content = this.cacheDataPopin[dataCode];

        if ($('.popinActivity-fancybox').length) {
          $('.fancybox-slide').html(content);
          $('.popinActivity').append('<button data-fancybox-close class="fancybox-close-small" title="Close" />');
        } else {
          window.fancybox.open(content, fancyboxOptions);
        }

        if ($('.popinActivity .js-sliderPhotos').length) {
          sliderPhotosModule().then(({sliderPhotos}) => {
            $('.popinActivity .js-sliderPhotos').data('directrender', true);
            sliderPhotos.initialize();
          });
        }

        if ($('.popinActivity .js-fancybox-video').length) {
          new FancyboxView({
            selector: '.js-fancybox-video',
            fancyType: 'custom',
            allowDoubleFancy: true,
            options: {
              buttons: ['close'],
              overlayClose: false,
              isModal: false,
              preventScroll: true,
              clickSlide: false,
              clickOutside: false,
              touch: true,
              loop: true,
              baseClass: 'fancybox-skin--white fancybox-skin--white_slide-in-top'
            }
          });

          $('.popinActivity-video.js-fancybox-video').on('click', () => {
            Tracking.dataLayerPush({
              event: 'clickEvent',
              clickCode: 'ClickActivityDetails',
              gaCategory: PAGE_SCRIPTS.page_template,
              gaAction: 'activityDetails',
              gaLabel: 'videos play'
            });
          });
        }

        if (DEVICE.isMobile) {
          $('.popinActivity').off('scroll').on('scroll', () => {
            this.setStickyCloseBtn();
          });
        }

        button.clearButtonLoader();
        genericToggle.init('.popinActivity .api_toggle');

        if ($('.js-showVirtualTour').length) {
          virtualTourModule().then(({virtualTour}) => {
            virtualTour.init();
          });
        }
      };

      if (typeof this.cacheDataPopin[dataCode] === 'undefined') {
        genericAjaxCall({
          ajaxUrl: `${GLOBAL_SCRIPTS.URL_API_PRESTATION}activity/${GLOBAL_SCRIPTS.UNIVERS}/${GLOBAL_SCRIPTS.LANGUAGE_CODE}/SUMMER/${offerCode}/${offerCode}${dataCode}`,
          ajaxParams: {},
          successCallback: result => {
            result.data.prevActivite = dataPrevCode;
            result.data.nextActivite = dataNextCode;
            this.cacheDataPopin[dataCode] = popinActivityTpl({
              data: result.data,
              wordings: WORDINGS_FANCYBOX_JSON,
              urlBase: GLOBAL_SCRIPTS.STATIC_VERSION
            });
            successCallback();
          },
          abortable: true,
          origin: 'popinActivity',
          dataType: 'json',
          type: 'GET'
        });
      } else {
        successCallback();
      }
    });
  },

  setStickyCloseBtn: function () {
    const initialTop = $('.popinActivity-visuals').offset().top - $(window).scrollTop();
    if (initialTop <= 30) {
      $('.fancybox-close-small').addClass('is-sticky');
    } else {
      $('.fancybox-close-small').removeClass('is-sticky');
    }
  }
};